module.exports = __webpack_public_path__ + "9a81ce82887cab792d3562183b53da59.svg";